export default {"src":"/_next/static/media/vocaltracks.b9a8507d.svg","height":40,"width":27,"blurWidth":0,"blurHeight":0};